/**
 * Shared look for every quality-formula table's column header (background, caps, weight) —
 * `padding` is the one thing each table still sets for itself, since row density varies
 * (e.g. Price Components' rows are shorter than the Range rows table's).
 */
export const TABLE_HEADER_STYLE: React.CSSProperties = {
  background: 'var(--mkf-table-header-bg)',
  color: 'var(--mkf-table-header-text)',
  fontSize: 11,
  fontWeight: 700,
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
};
